import { render, staticRenderFns } from "./MentionBox.vue?vue&type=template&id=009c847f&scoped=true&"
import script from "./MentionBox.vue?vue&type=script&lang=js&"
export * from "./MentionBox.vue?vue&type=script&lang=js&"
import style0 from "./MentionBox.vue?vue&type=style&index=0&id=009c847f&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "009c847f",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/danford/drochat/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('009c847f')) {
      api.createRecord('009c847f', component.options)
    } else {
      api.reload('009c847f', component.options)
    }
    module.hot.accept("./MentionBox.vue?vue&type=template&id=009c847f&scoped=true&", function () {
      api.rerender('009c847f', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "app/javascript/dashboard/components/widgets/mentions/MentionBox.vue"
export default component.exports